import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import api, { operation } from '../../services/axios'
import { StoreState } from '../../store'
import {
    Container,
    PaginationContainer,
    Title,
    Recurrences,
    HeaderRecurrences,
    Content,
} from './styles'
import { Pagination } from '@mui/material'

import Loading from '../../components/Loading'
import { get } from 'lodash'
import { BsPlus } from 'react-icons/bs'
import classNames from 'classnames'
import CreatedByYou from '../../components/Recurrence/CreatedByYou'
import ReceivedByYou from '../../components/Recurrence/ReceivedByYou'

const RecorrenciasGerenciar: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const [sentRecurrences, setSentRecurrences] = useState([])
    const [sentRecurrencesCount, setSentRecurrencesCount] = useState(0)
    const [sentRecurrencesPage, setSentRecurrencesPage] = useState(1)
    // const [loadingSentRecurrence, setLoadingSentRecurrence] = useState(false)
    // ---------------------------------------------------------------
    const [receivedRecurrences, setReceivedRecurrences] = useState([])
    const [receivedRecurrencesCount, setReceivedRecurrencesCount] = useState(0)
    const [receivedRecurrencesPage, setReceivedRecurrencesPage] = useState(1)
    // const [loadingReceivedRecurrence, setLoadingReceivedRecurrence] =
    //     useState(false)

    const [isLoading, setIsLoading] = useState(false)
    const [createdByYou, setCreatedByYou] = useState(true)
    const [receivedByYou, setReceivedByYou] = useState(false)

    const getSentRecurrences = useCallback(async () => {
        try {
            // setLoadingSentRecurrence(true)
            setIsLoading(true)
            const { data } = await api.get(
                `/recorrencia/sent/${cnpj_cpf}/${sentRecurrencesPage}`
            )
            setSentRecurrences(data.sentRecurrences)
            setSentRecurrencesCount(data.sentRecurrencesCount)
            // setLoadingSentRecurrence(false)
            setIsLoading(false)
        } catch (error) {
            // setLoadingSentRecurrence(false)
            setIsLoading(false)
        }
    }, [cnpj_cpf, sentRecurrencesPage])
    useEffect(() => {
        getSentRecurrences()
    }, [getSentRecurrences])

    const getReceivedRecurrences = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                // setLoadingReceivedRecurrence(true)
                setIsLoading(true)
                const { data } = await api.get(
                    `/recorrencia/received/${cnpj_cpf}/${receivedRecurrencesPage}`
                )
                setReceivedRecurrences(data.receivedRecurrences)
                setReceivedRecurrencesCount(data.receivedRecurrencesCount)
                // setLoadingReceivedRecurrence(false)
                setIsLoading(false)
            } catch (e: any) {
                // setLoadingReceivedRecurrence(false)
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf, receivedRecurrencesPage])
    useEffect(() => {
        getReceivedRecurrences()
    }, [getReceivedRecurrences])

    return (
        <Container>
            <HeaderRecurrences>
                <ul>
                    <li
                        className={classNames({
                            'active ': createdByYou,
                        })}
                    >
                        <button
                            onClick={() => {
                                setCreatedByYou(true)
                                setReceivedByYou(false)
                            }}
                        >
                            Criadas por você
                        </button>
                    </li>
                    <li
                        className={classNames({
                            'active ': receivedByYou,
                        })}
                    >
                        <button
                            onClick={() => {
                                setCreatedByYou(false)
                                setReceivedByYou(true)
                            }}
                        >
                            Recebidas por você
                        </button>
                    </li>
                </ul>
            </HeaderRecurrences>
            <Content>
                <Title>
                    <Link to="/pagamento/criar?recorrencia=true">
                        <button className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md ">
                            {/* <BiLink size={22} /> */}
                            {/* <AiOutlinePlus size={20} /> */}
                            {/* <HiOutlinePlus size={22} /> */}
                            <BsPlus size={24} />
                            Criar recorrência
                        </button>
                    </Link>
                </Title>
                <Recurrences>
                    {isLoading ? (
                        <Loading />
                    ) : (
                        <>
                            {createdByYou && (
                                <CreatedByYou
                                    sentRecurrences={sentRecurrences}
                                />
                            )}
                            {receivedByYou && (
                                <ReceivedByYou
                                    receivedRecurrences={receivedRecurrences}
                                />
                            )}
                        </>
                    )}
                </Recurrences>

                <PaginationContainer>
                    {createdByYou && (
                        <Pagination
                            onChange={(e, value) =>
                                setSentRecurrencesPage(value)
                            }
                            page={sentRecurrencesPage}
                            count={sentRecurrencesCount}
                            color="primary"
                            variant="outlined"
                            shape="rounded"
                        />
                    )}
                    {receivedByYou && (
                        <Pagination
                            onChange={(e, value) =>
                                setReceivedRecurrencesPage(value)
                            }
                            page={receivedRecurrencesPage}
                            count={receivedRecurrencesCount}
                            color="primary"
                            variant="outlined"
                            shape="rounded"
                        />
                    )}
                </PaginationContainer>
            </Content>
        </Container>
    )
}

export default RecorrenciasGerenciar
